type RefreshCallback = () => Promise<string | null>

class TokenManager {
    private accessToken: string | null = null
    private expiresAt = 0
    private refreshTimer: ReturnType<typeof setTimeout> | null = null
    private refreshCallback: RefreshCallback | null = null

    static readonly REFRESH_BUFFER_MS = 60_000
    static readonly WARNING_BUFFER_MS = 120_000

    getAccessToken(): string | null {
        return this.accessToken
    }

    setToken(token: string, expiresInSeconds: number): void {
        this.accessToken = token
        this.expiresAt = Date.now() + expiresInSeconds * 1000
        this.scheduleProactiveRefresh(expiresInSeconds)
    }

    clear(): void {
        this.accessToken = null
        this.expiresAt = 0
        this.cancelScheduledRefresh()
    }

    isValid(): boolean {
        return !!this.accessToken && Date.now() < this.expiresAt
    }

    getTimeUntilExpiryMs(): number {
        if (!this.accessToken) return 0
        return Math.max(0, this.expiresAt - Date.now())
    }

    getExpiresAt(): number {
        return this.expiresAt
    }

    setRefreshCallback(cb: RefreshCallback): void {
        this.refreshCallback = cb
    }

    private scheduleProactiveRefresh(expiresInSeconds: number): void {
        this.cancelScheduledRefresh()
        const refreshInMs = Math.max(
            0,
            expiresInSeconds * 1000 - TokenManager.REFRESH_BUFFER_MS
        )
        if (refreshInMs <= 0) return

        const jitter = Math.floor(Math.random() * 30_000)

        this.refreshTimer = setTimeout(async () => {
            if (this.refreshCallback) {
                await this.refreshCallback()
            }
        }, refreshInMs + jitter)
    }

    private cancelScheduledRefresh(): void {
        if (this.refreshTimer) {
            clearTimeout(this.refreshTimer)
            this.refreshTimer = null
        }
    }
}

export const tokenManager = new TokenManager()
